import React from "react";
import "./styles/Navbar.css";
import Logo from "./images/namelogo.png";

const NavbarMobile = ({ setActiveSection, activeSection }) => {
	const handleLinkClick = (section) => {
		console.log("Button clicked for section:", section);

		setActiveSection(section);
	};

	return (
		<nav className="navbar-lower">

			<div className="navbarmobilecontainer">
				{/* <div className="logospacer">
					<div className="logocontainer">
						<img src={Logo} alt="RDS Logo" className="navbarlogo" />
					</div>
				</div> */}
				<ul className="navmenu">
				{activeSection !== "Home" && (
					<li className="navitem">
						<button
							className="navlinks"
							onClick={() => handleLinkClick("Home")}
						>
							Home
						</button>
					</li>
				)}
				{/* <li className="navitem">
						<button
							className="navlinks"
							onClick={() => handleLinkClick("Music")}
						>
							Original Music
						</button>
					</li> */}
					<li className="navitem">
						<button
							className="navlinks"
							onClick={() => handleLinkClick("DJMixes")}
						>
							DJ Mixes
						</button>
					</li>
					<li className="navitem">
						<button
							className="navlinks"
							onClick={() => handleLinkClick("Lighting")}
						>
							Lighting
						</button>
					</li>
					{/* <li className="navitem">
						<button
							className="navlinks"
							onClick={() => handleLinkClick("Cinematography")}
						>
							Cinematography
						</button>
					</li> */}
					{/* <li className="navitem">
						<button className="navlinks" onClick={() => handleLinkClick("VFX")}>
							VFX
						</button>
					</li>
					<li className="navitem">
						<button
							className="navlinks"
							onClick={() => handleLinkClick("Graphics")}
						>
							Graphics
						</button>
					</li> */}
					{/* <li className="navitem">
						<button
							className="navlinks"
							onClick={() => handleLinkClick("WebDesign")}
						>
							Web Design
						</button>
					</li> */}
					
				</ul>
			</div>
		</nav>
	);
};

export default NavbarMobile;
